import React from "react";
import { View, StyleSheet } from "react-native";
import color from "@constants/color";
import Text from "@components/CustomText";
import { colors } from "@constants/theme";

interface LineItem {
  key: string;
  title: string;
  value: string;
}

interface PayoutPlanProps {
  title: string;
  lines: LineItem[];
}

const PayoutComponent: React.FC<PayoutPlanProps> = ({
  title = "",
  lines = [],
}) => {
  return (
    <View>
      <Text variant="title_18_regular">{title}</Text>
      {lines.map((line, index) => (
        <View key={index} style={styles.lineItem}>
          {line.title ? <Text variant="body_text_3">{line.title}</Text> : null}
          <Text variant="body_text_3" style={styles.lineText}>
            {line.value}
          </Text>
        </View>
      ))}
    </View>
  );
};

const styles = StyleSheet.create({
  lineItem: {
    backgroundColor: colors.lightgrey2,
    borderRadius: 8,
    padding: 12,
    marginVertical: 10,
    flexDirection: "row",
  },
  incentiveItem: {
    borderWidth: 1,
    borderColor: color.lighterBlack,
  },
  lineText: {
    marginLeft: 4,
  },
});

export default PayoutComponent;
